import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-girder",
  "use": "icon-girder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-girder\"><path d=\"M896 256v42.667H128V256H42.667v512H128v-42.667h768V768h85.333V256zM412.373 459.093L563.2 640H412.373zM327.04 565.76L176.427 384H327.04zM460.8 384h150.827v180.907zm236.16 75.093L847.573 640H696.96zM896 565.76L745.387 384H896zM128 459.093L278.613 640H128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol